<template>
    <el-row class="calendar-container">
        <el-col :sm="12" :md="24" :lg="24">
            <div class="calendar-top">

                <el-popover popper-class="info-popover" ref="info-button-popover" placement="bottom" trigger="click"><calendar-legend-popover></calendar-legend-popover></el-popover>
                <div class="info-button el-icon-information" v-popover:info-button-popover></div>

                <div @click="previousYear" class="calendar-navigation calendar-year-left"><i class="el-icon-d-arrow-left"></i></div>
                <div @click="previousMonth" class="calendar-navigation calendar-month-left"><i class="el-icon-arrow-left"></i></div>
                <div class="calendar-date-top">{{current.year}} {{currentMonthName}}</div>
                <div @click="nextMonth" class="calendar-navigation calendar-month-right"><i class="el-icon-arrow-right"></i></div>
                <div @click="nextYear" class="calendar-navigation calendar-year-right"><i class="el-icon-d-arrow-right"></i></div>
            </div>
            <div class="calendar-main">
                <div v-for="y in 6" class="calendar-item-row" v-bind:key="y">
                    <calendar-day  v-for="x in 7" v-bind:key="x" v-bind:date="getDate(y,x)" v-bind:current="current"></calendar-day>
                    <!--<div v-for="x in 7" class="calendar-item" v-bind:key="x">{{getDate(y,x)}}</div>-->
                </div>
            </div>
        </el-col>
        <el-col :sm="12" :md="24" :lg="24" :class="calendarHoursContainerClass">
            <div class="calendar-hours">
                <el-row>
                    <el-col :sm="11" :md="24" v-for="hour in getSelectedDayHours.values" v-bind:key="hour">
                        <calendar-hour  v-bind:hour="hour"> </calendar-hour>
                    </el-col>
                </el-row>
            </div>
        </el-col>
    </el-row>
</template>

<style>
    .calendar-container{
        width:100%;
        height:100%;
        color:#ddd;
    }
    .calendar-top{
        position: relative;
        width:210px;
        height:25px;
        padding-top: 10px;
        user-select: none;
        cursor: default;
        margin-left: auto;
        margin-right: auto;
    }
    .info-button{
        position: absolute;
        left:-25px;
    }
    .info-button:hover{ color:#1BBC9B}
    
    .info-popover{
        min-width: 70px;
    }


    .calendar-year-left{
        width:15px;
    }
    .calendar-year-right{
        text-align: right;
        width: 15px;
    }
    .calendar-month-left{
        padding-left: 5px;
        width: 15px;
    }
    .calendar-month-right{
        padding-right: 5px;
        width: 15px;
        text-align: right;
    }
    .calendar-date-top{
        float:left;
        text-align: center;
        width: 140px;
    }
    .calendar-navigation {
        float:left;
        cursor: pointer;
    }
    .calendar-navigation:hover{
        color:#1BBC9B;
    }

    .calendar-main{
        width: 245px;
        height: 210px;
        margin-left:auto;
        margin-right: auto; 
        padding-bottom: 2px;
        border-bottom:1px solid #435060;
        margin-bottom:8px;
    }
    .calendar-item-row{
        width:245px;
    }
    .calendar-hours-container{
        height: calc(100% - 260px);
    }
    .calendar-hours-container.small{
        height: 260px;
    }
    .calendar-hours{
        overflow-y: auto;
        height: 100%;
    }

    


</style>

<script>
import * as utils from '../../common/utils';
import CalendarDay from './CalendarDay'
import CalendarHour from './CalendarHour'
import CalendarLegendPopover from './CalendarLegendPopover'
import {getDays, getSelectedDayHours, getSelectedDay, setSelectedDay,setSelectedHour, getMeasurementsDays, mounted} from '../../store/actions';
import { mapGetters } from 'vuex'

export default {
    props: ['small', 'screenSize', 'current', 'selectedDay'],
    components:{
        'calendar-day':CalendarDay,
        'calendar-hour':CalendarHour,
        'calendar-legend-popover': CalendarLegendPopover
    },
    computed:{
        ...mapGetters([
            'getSelectedDayHours',
            'getSelectedDay',
            'getLanguage'
        ]),
        currentMonthName:function(){
            var monthNames = {
                en:['January','Februar','March','April','May','June','July','August','September','October','November','December'],
                sl:['Januar','Februar','Marec','April','Maj','Junij','Julij','Avgust','September','Oktober','November','December'],
                at:['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                de:['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                fr:['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],

            };
            return monthNames[this.getLanguage][this.current.month];
        },
        firstDayOffset: function(){
            var offset = new Date(this.current.year, this.current.month, 1).getDay()-1;
            if(offset <= 0){
                offset+=7;
            }
            return offset;
        },
       
        calendarHoursContainerClass: function(){
            if(this.small) return 'calendar-hours-container small';
            return 'calendar-hours-container';
        },
        
    },
    methods:{
        getDate: function(y,x){
            var day = (y-1)*7+x;
            day-=this.firstDayOffset;
            var date = new Date(this.current.year, this.current.month, day);
            return date;
        },
        nextYear:function(){
            var newDate = new Date(this.current.year+1, this.current.month);
            this.current.year = newDate.getFullYear();
        },
        nextMonth: function(){
            var newDate = new Date(this.current.year,(this.current.month+1));
            this.current.month = newDate.getMonth();
            this.current.year = newDate.getFullYear();
        },
        previousYear: function(){
            var newDate = new Date(this.current.year-1,this.current.month);
            this.current.year = newDate.getFullYear();
        },
        previousMonth: function(){
            var newDate = new Date(this.current.year,(this.current.month-1));
            this.current.month = newDate.getMonth();
            this.current.year = newDate.getFullYear();
        },
    },
}
</script>





// WEBPACK FOOTER //
// Calendar.vue?04fa161d